import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './LiveSessionRoom.css';

const LiveSessionRoom: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isMuted, setIsMuted] = useState(false);
  const [isVideoOff, setIsVideoOff] = useState(false);
  const [chatMessages, setChatMessages] = useState([
    { id: 1, user: 'Ahmed', message: 'Hello everyone!', time: '15:05' },
    { id: 2, user: 'Sara', message: 'Hi!', time: '15:06' }
  ]);
  const [newMessage, setNewMessage] = useState('');

  const handleSendMessage = () => {
    if (newMessage.trim()) {
      setChatMessages([
        ...chatMessages,
        { id: chatMessages.length + 1, user: 'You', message: newMessage, time: '15:10' }
      ]);
      setNewMessage('');
    }
  };

  return (
    <div className="live-session-room-page">
      {/* Video Area */}
      <div className="video-area">
        <div className="main-video">
          <div className="video-placeholder-main">
            <div className="instructor-name">Dr. Smith</div>
            <div className="live-indicator">🔴 LIVE</div>
          </div>
        </div>
        
        {/* Participants Grid */}
        <div className="participants-grid">
          {[1, 2, 3, 4].map((num) => (
            <div key={num} className="participant-video">
              <div className="video-placeholder-small">
                Student {num}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Controls Bar */}
      <div className="controls-bar">
        <button 
          className={`control-btn ${isMuted ? 'active' : ''}`}
          onClick={() => setIsMuted(!isMuted)}
        >
          {isMuted ? '🔇' : '🎤'}
        </button>
        <button 
          className={`control-btn ${isVideoOff ? 'active' : ''}`}
          onClick={() => setIsVideoOff(!isVideoOff)}
        >
          {isVideoOff ? '📹' : '📹'}
        </button>
        <button className="control-btn">💬</button>
        <button className="control-btn">📋</button>
        <button className="control-btn end-call">📞</button>
      </div>

      {/* Chat Panel */}
      <div className="chat-panel">
        <div className="chat-header">
          <h3>Chat</h3>
          <button className="close-chat" onClick={() => navigate(-1)}>✕</button>
        </div>
        <div className="chat-messages">
          {chatMessages.map((msg) => (
            <div key={msg.id} className={`chat-message ${msg.user === 'You' ? 'own' : ''}`}>
              <div className="message-header">
                <span className="message-user">{msg.user}</span>
                <span className="message-time">{msg.time}</span>
              </div>
              <p className="message-text">{msg.message}</p>
            </div>
          ))}
        </div>
        <div className="chat-input-area">
          <input
            type="text"
            placeholder="Type a message..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
            className="chat-input"
          />
          <button className="send-button" onClick={handleSendMessage}>
            ➤
          </button>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default LiveSessionRoom;
